import '@shui/core/sh-pagination';

import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-pagination',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.accessible-next-label]': 'accessibleNextLabel() ?? null',
        '[attr.accessible-page-label]': 'accessiblePageLabel() ?? null',
        '[attr.accessible-pageof-label]': 'accessiblePageofLabel() ?? null',
        '[attr.accessible-previous-label]': 'accessiblePreviousLabel() ?? null',
        '[attr.current-page]': 'currentPage() ?? null',
        '[attr.pages]': 'pages() ?? null',
        '(clicked-page-move)': 'clickedPageMove.emit($event)',
        '(next-page-move)': 'nextPageMove.emit($event)',
        '(previous-page-move)': 'previousPageMove.emit($event)'
    }
})
export class ShPaginationComponent {
    /**
     * Apply descriptive aria-label attributes to the right arrow buttons to assist screen reader
     * users
     */
    public readonly accessibleNextLabel = input<string | number | undefined>(undefined);

    /**
     * Accessible label prefix for the page number, used in ARIA announcements (e.g., "Page 2 of
     * 5").
     */
    public readonly accessiblePageLabel = input<string | number | undefined>(undefined);

    /**
     * Accessible label separator between current and total pages, used in ARIA announcements (e.g.,
     * "Page 2 of 5"). Can be localized or replaced with a symbol like "/" for language neutrality.
     */
    public readonly accessiblePageofLabel = input<string | number | undefined>(undefined);

    /**
     * Apply descriptive aria-label attributes to the left arrow buttons to assist screen reader
     * users
     */
    public readonly accessiblePreviousLabel = input<string | number | undefined>(undefined);

    /** Defines which page is currently active. */
    public readonly currentPage = input<string | number | undefined>(undefined);

    /** Defines the total number of pages. */
    public readonly pages = input<string | number | undefined>(undefined);

    public readonly clickedPageMove = output<Event>();

    public readonly nextPageMove = output<Event>();

    public readonly previousPageMove = output<Event>();
}
